import { zxcvbn } from "@zxcvbn-ts/core";
import { useCallback, useState } from "react";

export const usePasswordStrength = () => {
  const [score, setScore] = useState<number>();

  const analyze = useCallback((password: string) => {
    const result = zxcvbn(password || "");
    setScore(result.score);
    return result;
  }, []);

  const validate = useCallback((password: string) => {
    const result = zxcvbn(password || "");
    return result.score > 1 ? true : `Password is too weak. ${result.feedback?.suggestions?.join(" ")}`.trim();
  }, []);

  return { score, analyze, validate };
};
